/**
 * BlockedOrders — encomendas em BLOCKED com motivo.
 * JA: qualquer user pode desbloquear; LOG importa.
 */
import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api.js';
import { useTableProfile } from '../../hooks/useTableProfile.js';
import { DataTable } from '@shared/UI/DataTable';
import '@shared/UI/DataTable/DataTable.css';

const date = (s) => s ? new Date(s).toLocaleString('pt-PT') : '';
const eur = (n) => new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(n || 0);

const BlockedOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { layoutConfig, saveLayout } = useTableProfile('gencrm_blocked');

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/orders', { params: { status_id: 2 } });
      setOrders(r.data);
    } catch (e) {
      setError(e.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const columns = useMemo(() => [
    { key: 'order_number', label: 'Ordem', width: 110, render: (o) => <Link to={`/cockpit/orders/${o.id}`}>#{o.order_number}</Link> },
    { key: 'customer_name', label: 'Cliente', width: 220, render: (o) => o.customer_name || '—' },
    { key: 'status_label', label: 'Motivo', width: 180, render: (o) => <span className="gencrm_badge gencrm_badge--red">{o.status_label}</span> },
    { key: 'blocked_at', label: 'Bloqueada por/em', width: 180, render: (o) => date(o.blocked_at) },
    { key: 'total_price', label: 'Total', width: 120, aggregate: 'sum', render: (o) => eur(o.total_price) },
    { key: 'acao', label: 'Ação', width: 130, hideable: false, render: (o) => (
      <Link to={`/cockpit/orders/${o.id}`} className="gencrm_btn gencrm_btn--xs">🔓 Desbloquear</Link>
    ) },
  ], []);

  return (
    <div className="gencrm_cockpit_blocked">
      {error && <div className="gencrm_ws_error">Erro: {error}</div>}
      <DataTable
        columns={columns}
        data={orders}
        rowKey={(o) => o.id}
        loading={loading}
        pageSize={20}
        density="compact"
        enableTotals
        emptyText="Sem encomendas bloqueadas."
        exportPrefix="gencrm_blocked"
        layoutConfig={layoutConfig}
        onLayoutChange={saveLayout}
      />
    </div>
  );
};

export default BlockedOrders;
